export default "__VITE_ASSET__e5f3bb03__"